exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top_exp{padding:20px 30px;background:#f5f5f5}.top_exp img{margin-right:28px}.top_exp .warn-box{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.list_content{padding:30px}\n", ""]);

// exports
